import React from 'react';
import {
  Row,
  Col,
  FormGroup,
  FormControl,
  ControlLabel
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";

import { connect } from 'react-redux';

import Button from "components/CustomButton/CustomButton.jsx";

import { makeAccountPayment, makeTigoMoneyPayment } from 'reducers/payment/paymentActions';

import PaymentDetail from './PaymentDetail';

import { CREDIT_DEBIT_CARD, TIGO_MONEY, ACCOUNT } from './paymentMethodConst'
import { PAYMENT_DETAIL_STORAGE } from 'constants/storageConst';
import { storeObject } from 'utils/Storage/StorageUtils';

class PayStep extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      phoneNumber: "",
      phoneNumberError: null
    };
  }

  componentWillMount() {
    storeObject(PAYMENT_DETAIL_STORAGE, this.props.quotasToPay);
  }

  isValidated() {

    const paymentMethod = this.props.quotasToPay.paymentMethod;

    if (!paymentMethod) {
      return false;
    }

    switch (paymentMethod.type) {

      case CREDIT_DEBIT_CARD:
        return false;

      case TIGO_MONEY:

        if (this.state.phoneNumber.length !== 8) {
          this.setPhoneNumberError();
          return false;
        }

        this.setState({
          phoneNumberError: null
        });

        return new Promise((resolve, reject) => {
          this.doTigoMoneyPayment(resolve, reject);
        });

      case ACCOUNT:

        return new Promise((resolve, reject) => {
          this.doAccountPayment(resolve, reject);
        });

      default:
        return false;
    }
  }

  buildPaymentDto() {
    return {
      saleOrderId: this.props.quotasToPay.saleOrder.id,
      totalToPay: this.props.quotasToPay.totalToPay,
      quotaToPayDtos: this.props.quotasToPay.quotasDetail,
      paymentMethodId: this.props.quotasToPay.paymentMethod.id
    };
  }

  doTigoMoneyPayment(resolve, reject) {
    let paymentDto = this.buildPaymentDto();
    this.props.makeTigoMoneyPayment(paymentDto, this.state.phoneNumber, resolve, reject);
  }

  doAccountPayment(resolve, reject) {
    let paymentDto = this.buildPaymentDto();
    this.props.makeAccountPayment(paymentDto, resolve, reject);
  }

  handlePhoneNumberChange(event) {
    this.setState({
      phoneNumber: event.target.value
    });
    event.target.value.length != 8
      ? this.setPhoneNumberError()
      : this.setState({ phoneNumberError: "" });
  }

  setPhoneNumberError() {
    this.setState({
      phoneNumberError: (
        <small className="text-danger">
          El número de billetera es requerido y debe tener 8 dígitos
          </small>
      )
    })
  }

  render() {
    let payStepClassName = 'wizard-step pay-step';
    if (this.props.quotasToPay.paymentMethod.type === CREDIT_DEBIT_CARD) {
      payStepClassName += ' pay-step-credit-card';
    }
    return (
      <div className={payStepClassName}>


        {this.props.quotasToPay.paymentMethod.type === CREDIT_DEBIT_CARD &&
          <Row>
            <Col md={7}>
              <iframe
                frameborder="0"
                height="1000"
                width="100%"
                src={this.props.payment.creditCardUrlPayment.url}></iframe>
            </Col>
            <Col md={5}>
              <PaymentDetail />
            </Col>
          </Row>
        }
        {this.props.quotasToPay.paymentMethod.type === TIGO_MONEY &&
          <Row>
            <Col md={7}>
              <Card
                title="Tigo Money"
                content={
                  <form>
                    <FormGroup>
                      <ControlLabel>Número de Billetera</ControlLabel>
                      <FormControl
                        placeholder="Ingresa Número de Billetera"
                        type="number"
                        onChange={event => this.handlePhoneNumberChange(event)}
                      />
                      {this.state.phoneNumberError}
                    </FormGroup>
                  </form>
                }
              />
            </Col>
            <Col md={5}>
              <PaymentDetail />
            </Col>
          </Row>
        }
        {this.props.quotasToPay.paymentMethod.type === ACCOUNT &&
          <Row>
            <Col md={6} mdOffset={3}>
              <PaymentDetail />
            </Col>
          </Row>
        }
      </div >
    );
  }
}

const mapStateToProps = state => ({
  payment: state.payment,
  quotasToPay: state.quotasToPay,
  accountInfo: state.account.info
});

export default connect(
  mapStateToProps,
  { makeAccountPayment, makeTigoMoneyPayment },
  null,
  { withRef: true }
)(PayStep);



// WEBPACK FOOTER //
// ./src/components/PaymentWizard/PayStep.jsx